var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-img',{attrs:{"src":"https://cdn.vuetifyjs.com/images/cards/desert.jpg","aspect-ratio":"2.75"}}),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.currentCategory.name))]),_c('div',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.currentCategory.description))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }